import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/viadeo': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M276.2 150.5v0.7c-17.9-52.6-42.6-103.4-70.8-151.2 43.3 29.2 67 100 70.8 150.5zM308.9 272.2c15.1-3.1 29.5-9 42.2-17 24.5 58.6 20.2 139.7-36.4 201-67.8 73.9-191.9 74.6-259.8 0-108.8-117.8-31.6-313.7 129.9-313.7 21.3 0 42.6 3.5 62.5 10.7-6.9 13.4-11.7 28.2-13.4 43.3-15.4-6.5-32.3-9.6-49.1-9.6-78 0-135.4 66.7-135.4 142.3 0 68.8 45.6 126 111.3 137.4 98.5-38.4 116.6-188.2 116.6-280 0-11.7 0-23.7-1-35.4 12.4 36.1 18.9 73.9 18.9 112 0 86.5-35.1 158.4-109.3 205.1l-3.8 0.3c80 1.6 137.8-61.7 137.8-139.4 0-19.5-3.4-38.8-11-57zM418.1 11.7c52 74 20.9 208.6-58.1 208.6-21.3 0-40.2-11.4-55-25.8 35.1-19.3 79.4-49.2 99.7-84.9 2.4-4.8 6.5-13.7 7.2-19.2-19.9 44.7-70.8 79.7-118.2 90.7-7.5-11.7-12-24.7-12-38.8 0-16.5 8.2-38.5 20.6-50.5 34.5-32.9 84.8-13.6 115.8-80.1z'
      }
    ]
  }
})
